import { OperatorFunction } from 'rxjs';
import { map, concatAll, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { windowByComparator } from './window-by-comparator-operator';
import { SectionStatusEvent, progressEquals } from '@/app/statistics/events/section-status-events';

export function filterStatusEventsOperator(params: { debounceMs: number }): OperatorFunction<
      SectionStatusEvent, SectionStatusEvent> {

  return (input$) => input$.pipe(
    windowByComparator(compareSectionId),
    map((x) => x.pipe(
      distinctUntilChanged((a, b) => compareDetails(a, b)),
      debounceTime(params.debounceMs)
    )),
    concatAll());

  function compareSectionId(event1: SectionStatusEvent, event2: SectionStatusEvent) {
    return event1.payload.sectionId === event2.payload.sectionId;
  }

  function compareDetails(event1: SectionStatusEvent, event2: SectionStatusEvent) {
    const equal = progressEquals(event1.payload.progress, event2.payload.progress);

    return equal;
  }
}
